import { createTheme } from '@mui/material/styles';
import { colorsToken } from './colors-token';
import { typographyToken } from './typography-token';
import { grey } from '@mui/material/colors';

const lightTheme = createTheme({
	palette: {
		mode: 'light',
		primary: {
			main: '#996515',
			light: colorsToken.colors.primary['200'],
			dark: colorsToken.colors.primary['600'],
		},
		secondary: { main: grey[600] },
		background: {
			default: colorsToken.colors.neutral['100'],
			paper: colorsToken.colors.white,
		},
		text: {
			primary: colorsToken.colors.neutral['900'],
			secondary: colorsToken.colors.neutral['600'],
		},
		success: { main: colorsToken.colors.success['500'] },
		warning: { main: colorsToken.colors.info['200'] },
		error: { main: colorsToken.colors.error['500'] },
		info: { main: colorsToken.colors.info['500'] },
	},

	// keep font settings here (unchanged)
	typography: {
		fontFamily: [
			'Brown',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
		fontWeightLight: Number(typographyToken.fontWeight.light),
		fontWeightRegular: Number(typographyToken.fontWeight.regular),
		fontWeightBold: Number(typographyToken.fontWeight.bold),

		h3: {
			fontSize: typographyToken.fontSize['2x-large'][0],
			lineHeight: typographyToken.fontSize['2x-large'][1],
			fontWeight: 'bold',
		},
		h5: {
			fontSize: typographyToken.fontSize.large[0],
			lineHeight: typographyToken.fontSize.large[1],
			fontWeight: 'bold',
		},
		h6: {
			fontSize: typographyToken.fontSize.medium[0],
			lineHeight: typographyToken.fontSize.medium[1],
			fontWeight: 500,
		},
		body2: {
			fontSize: typographyToken.fontSize.small[0],
			lineHeight: typographyToken.fontSize.small[1],
			fontWeight: 500,
		},
	},

	components: {
		// 🔥 apply primary.main automatically to headings
		MuiTypography: {
			styleOverrides: {
				h3: { color: '#996515' }, // <-- we replace with theme reference below
				h5: { color: '#996515' },
				h6: { color: '#996515' },
				body2: { color: grey[600] },
			},

			// OR recommended dynamic method via function:
			variants: [
				{
					props: { variant: 'h3' },
					style: ({ theme }) => ({
						color: theme.palette.primary.main,
					}),
				},
				{
					props: { variant: 'h5' },
					style: ({ theme }) => ({
						color: theme.palette.primary.main,
					}),
				},
				{
					props: { variant: 'h6' },
					style: ({ theme }) => ({
						color: theme.palette.primary.main,
					}),
				},
				{
					props: { variant: 'body2' },
					style: ({ theme }) => ({
						color: theme.palette.text.secondary,
					}),
				},
			],
		},

		MuiCard: { styleOverrides: { root: { borderRadius: 10 } } },
		MuiButton: { styleOverrides: { root: { textTransform: 'unset' } } },
		MuiInputBase: { styleOverrides: { root: { backgroundColor: colorsToken.colors.white } } },
		MuiAlert: { styleOverrides: { root: { borderRadius: 10 } } },
	},
});

export default lightTheme;
